<div class="flex flex-col items-center gap-6 md:flex-row md:items-start">
  <div class="flex w-full flex-col gap-4 md:w-2/3">
    @for (passengerForm of passengerForms.controls; track $index) {
      <div
        class="rounded-2xl border p-6"
        [ngStyle]="{
          borderColor: corporateDesign.primaryBorderColor(),
          backgroundColor: corporateDesign.surface1(),
          color: corporateDesign.isDarkModeActive()
            ? corporateDesign.corporateDesign().primaryDarkFontColor
            : corporateDesign.corporateDesign().colorAdmixtures
                .standard_text_high,
        }">
        <div class="mb-5 flex flex-row items-center justify-between">
          <div>
            <h3 class="text-xl font-semibold">
              {{
                textStore.texts()
                  | filterTexts
                    : ERelationType.onDemandTicketNumber
                    : EEntityType.onDemandTicketConfiguration
                  | language
              }}
              {{ $index + 1 }}
            </h3>
            <p class="text-base opacity-60">
              {{ getPassengerFahrgasttyp($index) }}
            </p>
          </div>
          <span
            class="material-symbols-rounded cursor-pointer text-2xl opacity-60"
            (click)="togglePassenger($index)">
            {{ expandedStates[$index] ? 'expand_less' : 'expand_more' }}
          </span>
        </div>

        @if (expandedStates[$index]) {
          <div class="flex flex-col gap-5" [formGroup]="passengerForm">
            <aw-checkbox
              [id]="'ticket-for-me-' + $index"
              [label]="
                textStore.texts()
                  | filterTexts
                    : ERelationType.ticketIsForMe
                    : EEntityType.onDemandTicketConfiguration
                  | language
              "
              formControlName="ticketForMe"
              (valueChange)="checkTicketForMe($index, $event)" />

            <aw-drop-down
              [id]="'passenger-salutation-' + $index"
              [label]="
                textStore.texts()
                  | filterTexts
                    : ERelationType.newCustomerSalutation
                    : EEntityType.onDemandTicketConfiguration
                  | language
              "
              formControlName="salutation"
              [options]="salutationOptions()"
              name="name"
              valueAttribute="id" />

            <aw-text-input
              [id]="'passenger-first-name-' + $index"
              [label]="
                textStore.texts()
                  | filterTexts
                    : ERelationType.newCustomerFirstName
                    : EEntityType.onDemandTicketConfiguration
                  | language
              "
              formControlName="firstName" />

            <aw-text-input
              [id]="'passenger-last-name-' + $index"
              [label]="
                textStore.texts()
                  | filterTexts
                    : ERelationType.newCustomerLastName
                    : EEntityType.onDemandTicketConfiguration
                  | language
              "
              formControlName="lastName" />

            <aw-date-input
              [id]="'passenger-birth-date-' + $index"
              [label]="
                textStore.texts()
                  | filterTexts
                    : ERelationType.personalDataBirthdate
                    : EEntityType.onDemandTicketConfiguration
                  | language
              "
              [darkModeLabelColor]="
                corporateDesign.corporateDesign().colorAdmixtures
                  .dark_text_disabled
              "
              formControlName="birthDate" />
          </div>
        }
      </div>
    }
  </div>

  <aw-on-demand-ticket-configuration-summary [showReservationDeadline]="true">
    <aw-button
      summary-action
      id="on-demand-passenger-next"
      type="button"
      [style]="'error'"
      [isDisabled]="passengerForms.invalid"
      (click)="navigateNext()">
      {{
        textStore.texts()
          | filterTexts
            : ERelationType.goToCheckout
            : EEntityType.onDemandTicketConfiguration
          | language
      }}
    </aw-button>
  </aw-on-demand-ticket-configuration-summary>
</div>
